module.exports = __webpack_public_path__ + "img/nodata_doc.b8ad3b5d.png";